// src/services/gatePassService.ts
import api from "../lib/api.ts";

export const downloadGatePassPdf = async (
  gatePassId: number
): Promise<Blob> => {
  const response = await api.get(
    `/gatepasses/buyer/${gatePassId}/pdf/download`,
    {
      responseType: "blob",
    }
  );
  return response.data;
};

export const streamGatePassPdf = async (gatePassId: number): Promise<Blob> => {
  const response = await api.get(`/gatepasses/buyer/${gatePassId}/pdf/stream`, {
    responseType: "blob",
  });
  return response.data;
};

export type GatePassRenewalType = "buyer" | "seller";

/**
 * Ask the admin to renew an expired gate pass. The admin sets the number of days
 * and creates the renewal invoice.
 */
export const requestGatePassRenewal = async (
  vehicleId: number,
  type: GatePassRenewalType
) => {
  const response = await api.post("/gatepass-renewals", { vehicleId, type });
  return response.data;
};

/**
 * The logged-in user's renewal requests (used to show pending state).
 */
export const getMyGatePassRenewalRequests = async (type: GatePassRenewalType) => {
  const response = await api.get("/gatepass-renewals/mine", { params: { type } });
  return response.data?.data || [];
};
